import {Component, HostListener, OnInit} from '@angular/core';
import {ActivatedRoute, NavigationEnd, NavigationStart, Router, RouterEvent, Scroll} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {MatSnackBar} from '@angular/material/snack-bar';
import {DocumentClickedService} from './services/document-clicked.service';
import {CurrentUserService} from './services/current-user.service';
import {environment} from '../environments/environment';
import {UserService} from './services/user.service';
import {ViewportScroller} from '@angular/common';
import {filter} from 'rxjs/operators';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  currentPage: string;
  profile: string;
  scrollTopPositions: { [url: string]: number } = {};

  constructor(public service: UserService,
              private router: Router,
              private route: ActivatedRoute,
              private documentClickedService: DocumentClickedService,
              private currentUserService: CurrentUserService,
              public translate: TranslateService,
              public snackBar: MatSnackBar) {
    translate.use('nl');
  }

  ngOnInit(): void {
    this.router.events.subscribe(() => this.currentPage = this.router.url);
    this.profile = environment.profile;
  }

  logout() {
    this.service.logout();
    this.currentUserService.delete();
    this.router.navigate(['/login']);
  }

  @HostListener('document:click', ['$event'])
  documentClick(event: any): void {
    this.documentClickedService.clicked.next(event.target);
  }
}
